module.exports = __webpack_public_path__ + "assets/images/flower2.b881c45c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Profile/components/Shared/FlowersAd/assets/flower2.jpg
// module id = 606
// module chunks = 0